import { Outlet } from "react-router-dom";
import HeadNav from "./HeadNav";

export default function Layout() {
  console.log("Layout")
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <div style={{ flex: 1 }}>
        <HeadNav />
        <div >
          <Outlet />
        </div>
      </div>
    </div>
  );
}
